import { Grid, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import solicitacoesRepository from '../SolicitacoesRepository'
import { FonteLiberacaoEnum } from './FonteLiberacao'

const SolicitacoesFonteLiberacaoHistorico = props => {
  const [quantidades, setQuantidades] = useState({})

  useEffect(() => {
    const fetchData = async cpfMotorista => {
      if (cpfMotorista) {
        const response = await solicitacoesRepository.fonteLiberacaoHistorico({
          cpfMotorista
        })
        if (response.ok) {
          setQuantidades(response.data)
        }
      }
    }
    fetchData(props.cpfMotorista)
  }, [props.cpfMotorista])

  return (
    <Grid container spacing={2}>
      <Grid item md xs={12}>
        <Typography>
          Central de Cadastros:{' '}
          {quantidades[FonteLiberacaoEnum.CENTRAL_CADASTROS]}
        </Typography>
      </Grid>
      <Grid item md={2} xs={12}>
        <Typography>
          Gestor: {quantidades[FonteLiberacaoEnum.GESTOR]}
        </Typography>
      </Grid>
      <Grid item md xs={12}>
        <Typography>
          Automaticamente: {quantidades[FonteLiberacaoEnum.AUTOMATICAMENTE]}
        </Typography>
      </Grid>
      <Grid item md xs={12}>
        <Typography>
          Não Recomendada: {quantidades[FonteLiberacaoEnum.NAO_RECOMENDAR]}
        </Typography>
      </Grid>
    </Grid>
  )
}

export { SolicitacoesFonteLiberacaoHistorico }
